(function () {
  const selector = "[data-instagram-embed-root]";
  /** @type {Promise<any> | null} */
  let embedScriptPromise = null;

  function loadInstagramScript() {
    if (window.instgrm?.Embeds) return Promise.resolve(window.instgrm);
    if (embedScriptPromise) return embedScriptPromise;

    embedScriptPromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector(
        "script[data-instagram-embed-script]",
      );

      if (existingScript) {
        existingScript.addEventListener("load", () => resolve(window.instgrm), {
          once: true,
        });
        existingScript.addEventListener("error", reject, { once: true });
        return;
      }

      const script = document.createElement("script");
      script.async = true;
      script.src = "https://www.instagram.com/embed.js";
      script.dataset.instagramEmbedScript = "true";
      script.addEventListener("load", () => resolve(window.instgrm), {
        once: true,
      });
      script.addEventListener("error", reject, { once: true });
      document.head.append(script);
    });

    return embedScriptPromise;
  }

  function createEmbedMarkup(container) {
    const url = container.dataset.instagramUrl;
    const displayName = container.dataset.instagramDisplayName || "Instagram";
    const username = container.dataset.instagramUsername || "";

    const blockquote = document.createElement("blockquote");
    blockquote.className = "instagram-media";
    blockquote.setAttribute("data-instgrm-permalink", url || "");
    blockquote.setAttribute("data-instgrm-version", "14");

    const card = document.createElement("div");
    card.className = "instagram-embed__card";

    const eyebrow = document.createElement("p");
    eyebrow.className = "instagram-embed__eyebrow";
    eyebrow.textContent = "Instagram";

    const title = document.createElement("h3");
    title.className = "instagram-embed__title h4";
    title.textContent = displayName;

    const handle = document.createElement("p");
    handle.className = "instagram-embed__copy";
    handle.textContent = username ? `@${username}` : displayName;

    const link = document.createElement("a");
    link.className = "instagram-embed__embed-link";
    link.href = url || "https://www.instagram.com/";
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.textContent = "View on Instagram";

    card.append(eyebrow, title, handle, link);
    blockquote.append(card);

    return blockquote;
  }

  async function hydrateInstagramEmbed(container) {
    if (container.dataset.instagramHydrated === "true") return;

    container.dataset.instagramHydrated = "true";
    container.dataset.instagramError = "false";
    container.classList.add("instagram-embed__container--loading");

    const placeholder = container.querySelector("[data-instagram-placeholder]");
    const embed = document.createElement("div");
    embed.className = "instagram-embed__embed";
    embed.hidden = true;
    embed.append(createEmbedMarkup(container));
    container.append(embed);

    try {
      await loadInstagramScript();
      window.instgrm?.Embeds?.process(container);
      embed.hidden = false;
      placeholder?.remove();
    } catch (error) {
      embed.remove();
      container.dataset.instagramHydrated = "false";
      container.dataset.instagramError = "true";
      console.error("Failed to load Instagram embed", error);
    } finally {
      container.classList.remove("instagram-embed__container--loading");
    }
  }

  function initializeInstagramEmbeds() {
    const containers = document.querySelectorAll(selector);
    if (!containers.length) return;

    const observer =
      "IntersectionObserver" in window
        ? new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                observer.unobserve(entry.target);
                hydrateInstagramEmbed(
                  /** @type {HTMLElement} */ (entry.target),
                );
              });
            },
            { rootMargin: "200px 0px" },
          )
        : null;

    containers.forEach((container) => {
      const loadButton = container.querySelector("[data-instagram-load]");
      loadButton?.addEventListener("click", () => hydrateInstagramEmbed(container));

      if (observer) {
        observer.observe(container);
      } else {
        hydrateInstagramEmbed(container);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeInstagramEmbeds, {
      once: true,
    });
  } else {
    initializeInstagramEmbeds();
  }
})();
